import { Component } from '@angular/core';

@Component({
  selector: 'app-closed-cases-list',
  templateUrl: './closed-cases-list.component.html',
  styleUrls: ['./closed-cases-list.component.css']
})
export class ClosedCasesListComponent {

}
